import axios from '@/plugins/axios';

export function uploadFiles(files: any, config: any) {
    const form = new FormData();
    for (let i = 0; i < files.length; i++) {
        form.append('files', files[i]);
    }
    return axios.post('/upload', form, config);
}